import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

/**
 * Unauthorized component
 * 
 * Displayed when a user attempts to access a route without proper permissions
 */
const Unauthorized: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
      <h1 className="text-6xl font-bold text-gray-900 mb-4">403</h1>
      <h2 className="text-2xl font-semibold text-gray-700 mb-6">Access Denied</h2>
      <p className="text-gray-500 max-w-md mb-8">
        You don't have permission to access this page. Please contact your administrator if you believe this is an error.
      </p>
      <Button asChild>
        <Link to="/">Return to Dashboard</Link>
      </Button>
    </div>
  );
};

export default Unauthorized;
